export enum UserType {
  PROSPECT = 'prospect',
  CLIENT = 'client',
  CREW = 'crew',
}
